var userAgent = require('../internals/engine-user-agent');

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];



//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/web/app/themes/sanacorp/node_modules/core-js/internals/engine-ff-version.js
// module id = 240
// module chunks = 0